var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeftQuote = function SvgLeftQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.44 20.82c-.23 0-.346-.112-.346-.338v-9.818c0-2.031.49-3.837 1.471-5.417.98-1.636 2.25-2.905 3.807-3.808C22.988.479 24.718 0 26.564 0v5.247c-1.442 0-2.682.536-3.72 1.609-.981 1.072-1.472 2.341-1.472 3.808h4.846c.23 0 .346.113.346.339v9.479c0 .226-.115.338-.346.338H16.44Zm-16.094 0c-.23 0-.346-.112-.346-.338v-9.818c0-2.031.49-3.837 1.471-5.417.98-1.636 2.25-2.905 3.807-3.808C6.893.479 8.624 0 10.47 0v5.247c-1.442 0-2.682.536-3.72 1.609-.981 1.072-1.472 2.341-1.472 3.808h4.846c.23 0 .346.113.346.339v9.479c0 .226-.116.338-.346.338H.346Z",
    fill: "#7F939D"
  })));
};
export default SvgLeftQuote;